import React, { useContext, useState } from 'react';
import { Button, Modal, Select, Toast } from '../../../../uiComponents/common';
import { useTranslation } from 'react-i18next';
import { Show } from '../../../../components';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { WelletContext } from '../../../../context/wellet/welletContext';
import { useMutation } from 'react-query';
import { putChangeAffiliateType } from '../../../../services';
import { Pencil } from 'lucide-react';
import { Button as ButtonShad } from '@/components/ui/button';
import { getAffiliateType } from '@/helpers/concierge';
import { useSelector } from 'react-redux';
const ChangeAffiliateType = ({
  setValue,
  affiliateType = null,
  canEditAffiliate,
  refetchStatus,
  categoryId,
  allCategoriesData,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'screens.profile',
  });
  const { t: tGeneric } = useTranslation();
  const navigate = useNavigate();

  const organization = useSelector((state) => state.app.selectedOrganization);
  const { id } = useParams();

  const welletContext = useContext(WelletContext);
  const [open, setOpen] = useState(false);

  const currentCategory = allCategoriesData?.data?.find((c) => c.id === categoryId);

  const methods = useForm({
    defaultValues: {
      affiliateType: { label: getAffiliateType(affiliateType, tGeneric), value: affiliateType },
      categoryId: categoryId
        ? {
            label: `${currentCategory?.name} (${currentCategory?.defaultCommissionPercentage}%)`,
            value: categoryId,
          }
        : null,
    },
  });

  const handleSetNewAffiliate = (affiliateType) => {
    setValue('affiliateType', affiliateType);
  };
  // Mutation
  const handleAffiliateTypeMutation = useMutation({
    mutationFn: (body) => {
      const response = putChangeAffiliateType(welletContext, organization.id, body);
      return response;
    },
    onSuccess: (data, variables) => {
      handleSetNewAffiliate(variables?.affiliateType);
    },
  });

  const handleCancel = () => {
    setOpen(false);
    methods.reset({
      affiliateType: { label: getAffiliateType(affiliateType, tGeneric), value: affiliateType },
      categoryId: categoryId
        ? {
            label: `${currentCategory?.name} (${currentCategory?.defaultCommissionPercentage}%)`,
            value: categoryId,
          }
        : null,
    });
  };
  const closeModal = () => {
    setOpen(false);
  };
  const openModal = () => {
    setOpen(true);
  };
  const onSubmit = (data) => {
    const body = {
      userId: id,
      affiliateType: data?.affiliateType?.value,
      categoryId: data?.affiliateType?.value !== 'INDEPENDENT' ? data?.categoryId?.value : null,
    };
    handleAffiliateTypeMutation.mutate(body);
  };

  const currentAffiliateType = methods.watch('affiliateType')?.value;

  const salesCategoryFormatted = allCategoriesData?.data
    ?.filter((c) => {
      const isLoyalty = c.schemeType === 'LOYALTY' && c.affiliateType === currentAffiliateType;
      const isFixedForConcierge = currentAffiliateType === 'CONCIERGE' && c.schemeType === 'FIXED' && c.affiliateType === currentAffiliateType;

      return isLoyalty || isFixedForConcierge;
    })
    .map((ca) => ({
      label: `${ca?.name} (${ca?.defaultCommissionPercentage}%)`,
      value: ca.id,
      description: ca.defaultCommissionPercentage,
    }));

  return (
    <>
      {canEditAffiliate ? (
        <ButtonShad
          size='icon'
          variant='ghost'
          type='button'
          className='tw-absolute tw-right-1 tw-top-1 tw-h-8 tw-w-8'
          onClick={openModal}
        >
          <Pencil className='tw-h-4 tw-w-4' />
        </ButtonShad>
      ) : null}
      <Modal
        title={t('changeAffiliate.title')}
        open={open}
        onClose={closeModal}
        closeIcon={false}
        maxWidth='450px'
        closeOnDocumentClick={false}
        customButtons={
          <>
            <div className='d-flex justify-content-end'>
              <Button
                text={t('changeAffiliate.cancel')}
                disabled={!handleAffiliateTypeMutation.isIdle}
                className={'btn-general btn-wellet-secondary white'}
                size={'medium'}
                onClick={handleCancel}
                type='button'
              />
              <Button
                text={t('changeAffiliate.submit')}
                disabled={!handleAffiliateTypeMutation.isIdle}
                className={'ml-2 btn-general btn-wellet-primary'}
                size={'medium'}
                onClick={methods.handleSubmit(onSubmit)}
                type='submit'
              />
            </div>
          </>
        }
      >
        <FormProvider {...methods}>
          <div className='tw-text-muted-foreground'>
            {t('changeAffiliate.subtitle', { name: getAffiliateType(affiliateType, tGeneric) })}
          </div>
          <form key={'affiliateChange'} className='tw-my-3'>
            <Select
              options={[
                { label: getAffiliateType('CONCIERGE', tGeneric), value: 'CONCIERGE' },
                { label: getAffiliateType('INDEPENDENT', tGeneric), value: 'INDEPENDENT' },
                { label: getAffiliateType('INTERNAL_STAFF', tGeneric), value: 'INTERNAL_STAFF' },
              ]}
              label={t('rowAffiliateType.label')}
              className={'tw-mb-6'}
              name={'affiliateType'}
              // onManualChange={() => methods.setValue('categoryId', null)}
              onManualChange={(e) => {
                if (e.value === affiliateType) {
                  methods.setValue('categoryId', {
                    label: `${currentCategory?.name} (${currentCategory?.defaultCommissionPercentage}%)`,
                    value: currentCategory?.value,
                  });
                } else {
                  methods.setValue('categoryId', null);
                }
              }}
              isRequired={true}
            />
            {methods.watch('affiliateType')?.value !== 'INDEPENDENT' ? (
              <Select
                options={salesCategoryFormatted}
                label={'Loyalty'}
                className={'tw-mb-6'}
                name={'categoryId'}
                isRequired={true}
              />
            ) : null}
          </form>
        </FormProvider>
      </Modal>
      <Show.When isTrue={handleAffiliateTypeMutation.isError}>
        <Toast
          message={t('changeAffiliate.toast.error')}
          type={`ERROR`}
          onCallback={() => {
            // handleCloseError();
            handleAffiliateTypeMutation.reset();
          }}
        />
      </Show.When>
      <Show.When isTrue={handleAffiliateTypeMutation.isSuccess}>
        <Toast
          message={t('changeAffiliate.toast.success')}
          type={`SUCCESS`}
          onCallback={() => {
            closeModal();
            handleAffiliateTypeMutation.reset();
            navigate(
              `/${
                handleAffiliateTypeMutation?.variables?.affiliateType === 'CONCIERGE'
                  ? 'sellers'
                  : handleAffiliateTypeMutation?.variables?.affiliateType === 'INDEPENDENT'
                  ? 'affiliates'
                  : 'internalStaff'
              }/${organization.marketId}/${id}/profile?tab=DOCUMENTATION_PROFESSIONAL`,
            );
            refetchStatus();
          }}
        />
      </Show.When>
    </>
  );
};

export default ChangeAffiliateType;
